// Простая карта: roomId -> { users:[], count:number }
const INIT = {
    rooms: {},      // подробный список пользователей по комнатам
    stats: {},      // только краткая статистика (для списков)
};

export const presenceTypes = {
    SET_ROOM_USERS: "presence/SET_ROOM_USERS",
    MERGE_STATS: "presence/MERGE_STATS",
    CLEAR_STATS: "presence/CLEAR_STATS"
};

export default function presenceReducer(state = INIT, action) {
    switch (action.type) {
        case presenceTypes.SET_ROOM_USERS: {
            const { roomId, users = [] } = action.payload || {};
            return {
                ...state,
                rooms: {
                    ...state.rooms,
                    [roomId]: { users, count: users.length }
                }
            };
        }
        case presenceTypes.MERGE_STATS: {
            // payload.rooms: { [roomId]: { count, users? } }
            const nextStats = { ...state.stats, ...(action.payload?.rooms || {}) };
            return { ...state, stats: nextStats };
        }
        case presenceTypes.CLEAR_STATS:
            return { ...state, stats: {} };
        default:
            return state;
    }
}
